import { render, staticRenderFns } from "./ParentViewUserInfo.vue?vue&type=template&id=6d72f07e&"
import script from "./ParentViewUserInfo.vue?vue&type=script&lang=js&"
export * from "./ParentViewUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports